import { render } from "./Modal.vue?vue&type=template&id=fa2ac624&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=fa2ac624&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fa2ac624"

export default script